import React from 'react'
import FirmwareGrid from '../modules/infrastructure/firmware/components/Firmware'

export default function FirmwareManagement() {
    return <FirmwareGrid />
}
